import React, { forwardRef } from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

const FluentTicketDiagonal = forwardRef<Svg, { fillColor?: string } & SvgProps>(
  (
    { fillColor = '#212121', ...props }: { fillColor?: string } & SvgProps,
    ref
  ) => (
    <Svg
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      ref={ref}
      {...props}
    >
      <Path
        d='M14.53 3.59a.75.75 0 00-1.06 0l-9.88 9.88a.75.75 0 000 1.06l1.069 1.068a2.75 2.75 0 013.742 3.742l1.069 1.07a.75.75 0 001.061 0l9.879-9.879a.75.75 0 000-1.06L19.34 8.4a2.75 2.75 0 01-3.742-3.742L14.53 3.59zm-2.12-1.06a2.25 2.25 0 013.182 0l1.171 1.172c.511.51.42 1.227.162 1.66a1.25 1.25 0 001.713 1.713c.433-.257 1.15-.349 1.66.162L21.47 8.41a2.25 2.25 0 010 3.182l-9.878 9.878a2.25 2.25 0 01-3.182 0l-1.172-1.171c-.51-.51-.42-1.228-.162-1.66a1.25 1.25 0 00-1.713-1.713c-.433.257-1.15.348-1.66-.163L2.53 15.591a2.25 2.25 0 010-3.182l9.88-9.879z'
        fill={fillColor}
      />
    </Svg>
  )
)

export default FluentTicketDiagonal
